import type { CalendarsUnionType } from 'owa-graph-schema';

export function canDelegateManageCategories(calendar: CalendarsUnionType): boolean {
    switch (calendar.__typename) {
        case 'LocalCacheForRemoteCalendarEntry':
        case 'LinkedCalendarEntryV2':
            return !!calendar.CanManageCategories;
        case 'LinkedCalendarEntry':
            return !!calendar.EffectiveRights?.ManageCategories;
        default:
            return false;
    }
}
